export enum ValidationMessages {
  required = 'This field is required.',
  minlength = 'Minimum 3 characters.',
  maxlength = 'Maximum 64 characters.',
  minlengthPhone = 'Minimum 10 symbols.',
  maxlengthPhone = 'Maximum 15 symbols.',
  email = 'Email format incorrect.',
  password = 'Password format incorrect.',
  alpha = 'Should contain only alphabets.',
  dateRange = 'Invalid date range.',
  year = 'Format should be YYYY.',
}
